import type { RevealedContactDto } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/dto";

export const REVEALED_CONTACT_EMPTY_DATA: RevealedContactDto = {
    id: "",
    linkedInUrl: "",
};
